// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3t_YK","title":"styles_title__1Jvbt"};